import { ROUTES } from "@/constants/routes";
import * as analytics from "@/utils/analytics";
import {
  appendSignupUtmParams,
  buildTemplateSignupParams,
  captureSignupUtm,
  parseSignupUtm,
  parseTemplateSignupIntent,
  stashTemplateSignupIntent,
} from "@cohesive/ui-components";

/**
 * Where Auth0 sends the visitor back. A fresh template intent rides inside the
 * path, so the callback handler needs no knowledge of it.
 */
export function templateSignupReturnTo(search: string, now?: number): string {
  const intent = parseTemplateSignupIntent(search, now);
  const params = intent ? buildTemplateSignupParams(intent) : null;
  if (!params) return ROUTES.HOME;
  appendSignupUtmParams(params, parseSignupUtm(search));
  return `${ROUTES.ONBOARDING.TEMPLATE_SETUP}?${params.toString()}`;
}

/** Second copy of the intent, for the round trip that loses appState. */
export function beginTemplateSignup(search: string, now?: number): void {
  captureSignupUtm(search, now);

  const intent = parseTemplateSignupIntent(search, now);
  if (!intent) return;

  stashTemplateSignupIntent(intent);
  analytics.trackTemplateSignupStarted({
    kind: intent.kind,
    cta: intent.cta,
    id: intent.id,
  });
}
